/**
 * Component class, use as base for your application components.
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Component: function() {
        return Component;
    },
    default: function() {
        return _default;
    }
});
var _accelerator = /*#__PURE__*/ _interopRequireDefault(require("./Accelerator"));
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var Component = /*#__PURE__*/ function() {
    "use strict";
    function Component() {
        var _this = this;
        _classCallCheck(this, Component);
        this.on = function() {};
        this.fire = function() {};
        if (this.constructor._instance) {
            return this.constructor._instance;
        }
        if (this.constructor.target === "") {
            throw new Error("You need to define a target.");
        }
        if (this.constructor._name === "") {
            throw new Error("You need to define a name.");
        }
        this.setElements();
        this.accelerator = new _accelerator.default();
        if ("IntersectionObserver" in window) {
            this._intersectionObserver = new window.IntersectionObserver(this.onIntersect.bind(this), this.constructor.intersectionConfig);
            this.each(function(param) {
                var el = param.el;
                return _this._intersectionObserver.observe(el);
            });
        }
        if ("ResizeObserver" in window) {
            this._resizeObserver = new window.ResizeObserver(this.onResize.bind(this));
            this.each(function(param) {
                var el = param.el;
                return _this._resizeObserver.observe(el);
            });
        }
        if ("MutationObserver" in window) {
            this._mutationObserver = new window.MutationObserver(this.onMutation.bind(this));
            this.each(function(param) {
                var el = param.el;
                return _this._mutationObserver.observe(el, _this.constructor.mutationConfig);
            });
        }
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        window.onpagehide = this.destroy;
        window.onload = this.load;
        window.onunload = this.unload;
        this.on("load-component", this.componentMounted.bind(this));
        this.fire("component-loaded", {
            component: this,
            elements: this._el
        });
        this.constructor._instance = this;
    }
    var _proto = Component.prototype;
    _proto.setElements = function setElements() {
        this._el = Array.from(document.body.querySelectorAll(this.constructor.target));
    };
    _proto.componentMounted = function componentMounted() {};
    _proto.onIntersect = function onIntersect(param, observer) {
        var _param = _slicedToArray(param, 1), entry = _param[0];
    };
    _proto.onResize = function onResize(param, observer) {
        var _param = _slicedToArray(param, 1), entry = _param[0];
    };
    _proto.onMutation = function onMutation(param, observer) {
        var _param = _slicedToArray(param, 1), entry = _param[0];
    };
    _proto.forceReload = function forceReload() {
        this.setElements();
        this.fire("load-component");
        this.fire("component-loaded");
    };
    _proto.load = function load() {};
    _proto.unload = function unload() {};
    _proto.destroy = function destroy() {
        var _this_accelerator, _this_accelerator_removeAllSubscribers, _this__intersectionObserver, _this__resizeObserver;
        if (this.all) {
            this.all.forEach(function(el) {
                return el.remove();
            });
        }
        (_this_accelerator = this.accelerator) === null || _this_accelerator === void 0 ? void 0 : (_this_accelerator_removeAllSubscribers = _this_accelerator.removeAllSubscribers) === null || _this_accelerator_removeAllSubscribers === void 0 ? void 0 : _this_accelerator_removeAllSubscribers.call(_this_accelerator);
        (_this__intersectionObserver = this._intersectionObserver) === null || _this__intersectionObserver === void 0 ? void 0 : _this__intersectionObserver.disconnect();
        (_this__resizeObserver = this._resizeObserver) === null || _this__resizeObserver === void 0 ? void 0 : _this__resizeObserver.disconnect();
    };
    /**
     * Calls the passed function on all elements bound to this component.
     *
     * @param {CallableFunction} fun
     */ _proto.each = function each(fun) {
        var _this = this;
        this.all.forEach(function(el) {
            return fun({
                el: el,
                Component: _this
            });
        });
    };
    /**
     * Calls the passed function on all elements bound to this component.
     *
     * @param fun
     */ _proto.eachElement = function eachElement(fun) {
        this.all.forEach(function(el) {
            return fun(el);
        });
    };
    /**
     * Calls the passed function on all function matching the where function.
     *
     * @param {CallableFunction} fun The function called on all fitting results
     * @param {CallableFunction} where The function filtering the data.
     */ _proto.some = function some(fun, where) {
        var _this = this;
        this.all.filter(function(value, index, array) {
            return where({
                value: value,
                index: index,
                array: array
            });
        }).forEach(function(el) {
            return fun({
                el: el,
                Component: _this
            });
        });
    };
    /**
     * Debug info to help with development.
     */ _proto.dump = function dump() {
        console.log("".concat(this.constructor._name, " subscriber count:"), this.accelerator.getSubscriberCount());
        console.log("".concat(this.constructor._name, " subscribers:"), this.accelerator.getSubscribers().join(", "));
        console.log("".concat(this.constructor._name, " elements:"), this.all);
    };
    _createClass(Component, [
        {
            key: "first",
            get: function get() {
                return this.all[0];
            }
        },
        {
            key: "all",
            get: function get() {
                return this._el;
            }
        }
    ], [
        {
            key: "intersectionConfig",
            get: function get() {
                return {
                    rootMargin: "0px",
                    threshold: [
                        0,
                        1
                    ]
                };
            }
        },
        {
            key: "mutationConfig",
            get: function get() {
                return {
                    subtree: true,
                    childList: true
                };
            }
        }
    ]);
    return Component;
}();
/**
     * The target string to bind this Component to.
     */ Component.target = "";
/**
     * The component name. Used internally.
     */ Component._name = "";
var _default = Component;
